import React, { FC, memo, useMemo } from 'react';
import { useGetSizeCodesByWarehouseIdQuery } from 'entities/SizeCode';
import { ModernSelect as Select } from 'shared/ui/ModernSelect';
import { formatDecimal } from 'shared/utils/helpers/formatDecimal';

interface SizeCodeSelectProps {
  warehouseId: string | undefined;
  value: Nullable<string> | undefined;
  onChange: (value: string) => void;
}

export const SizeCodeSelect: FC<SizeCodeSelectProps> = memo((props) => {
  const { warehouseId, value, onChange } = props;

  const { data } = useGetSizeCodesByWarehouseIdQuery(warehouseId, { skip: !warehouseId });

  const options = useMemo(() => {
    return data?.map(({ sizeCodeId, square }) => ({ label: `${formatDecimal(square)} m²`, value: sizeCodeId })) || [];
  }, [data]);

  return <Select className="w-full" size="extraSmall" bordered value={value} options={options} onChange={onChange} />;
});
